import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Login } from '@models/login/login';
import { UserLogin } from '@models/user/user-login';

import { HttpService } from '@services/http.service';
import { HttpHeaders } from '@angular/common/http';
import { EndpointParams } from '@models/utils/endpoint-params';
import { MagicLinkLogin } from '@models/index';
import { InternationalizationService } from './utils/internationalization/internationalization.service';

@Injectable({
    providedIn: 'root'
})
export class UserService extends HttpService {
    private readonly internationalizationService = inject(InternationalizationService);
    private readonly defaultEndpointParams: EndpointParams = { app: 'member', version: 1 };

    login(login: Login, idCenter: number): Observable<UserLogin[]> {
        const headers = new HttpHeaders({ 'X-idcenterrequest': idCenter.toString(), 'X-origin': 'easy' });
        const languageCode = this.internationalizationService.getLanguage();

        return this.post(`auth/list?language_code=${languageCode}`, this.defaultEndpointParams, login, { headers });
    }

    magicLinkLogin(login: MagicLinkLogin, idCenter: number): Observable<UserLogin[]> {
        const headers = new HttpHeaders({ 'X-idcenterrequest' : idCenter.toString(), showErrorMessage: 'false' });
        const languageCode = this.internationalizationService.getLanguage();

        return this.post(`auth/list/magiclink/exchange?language_code=${languageCode}`, { app: 'member', version: 2 }, login, { headers });
    }
}
